<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('placeOrder.BatchExport')"
    :visible.sync="dialogVisibleExport"
    top="10vh"
    width="500px"
    @close="clearForm"
  >
    <el-form
      ref="exportOrderFormRef"
      :model="exporOrderForm"
      class="demo-exporOrderForm"
      label-position="top"
    >
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur', 'change']
        }"
        prop="NumberType"
      >
        <el-select v-model="exporOrderForm.NumberType" style="width: 60%">
          <!--运单号-->
          <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" :value="1" />
          <!--扫描单号-->
          <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur']
        }"
        prop="inputNumber"
        style="width: 100%"
      >
        <el-input
          v-model="exporOrderForm.inputNumber"
          :placeholder="$t('mdfeTranslate.multipleLineInput')"
          clearable
          rows="6"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin: 15px 0">
      <el-button
        size="small" @click="dialogVisibleExport = false"
      >{{ $t('GlobalSetObj.Cancelar') }}
      </el-button>
      <el-button
        size="small" type="primary" @click="comfireExport"
      >{{ $t('collectionCenter.CheckItOutNow') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { complaintWorkBatchNumberExport } from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'OrderNumberExport',
  data() {
    return {
      dialogVisibleExport: false,
      exporOrderForm: {
        NumberType: 1,
        inputNumber: ''
      }
    };
  },
  methods: {
    handleOpen() {
      this.dialogVisibleExport = true;
    },
    clearForm() {
      this.exporOrderForm.NumberType = 1;
      this.exporOrderForm.inputNumber = '';
    },
    comfireExport() {
      this.$refs['exportOrderFormRef'].validate((valid) => {
        if (valid) {
          const numberList = this.exporOrderForm.inputNumber
            ? this.exporOrderForm.inputNumber.split('\n')
            : [];
          let numList = numberList.filter((item) => item !== '');
          if (numList && numList.length > 100000) {
            numList = numList.slice(0, 100000);
            this.$message.warning(this.$t('mdfeTranslate.queryLimitNotice'));
            // return;
          }
          const param = {
            numberType: this.exporOrderForm.NumberType,
            numberSet: numList
          };
          complaintWorkBatchNumberExport(param).then(() => {
            this.dialogVisibleExport = false;
            goResourceTaskList();
          });
          console.log(param, 'param');
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
